import r from "../managers/braze-instance.js";
import nr from "./feature-flags-provider-factory.js";
import { getAllFeatureFlags } from "./get-all-feature-flags.js";
export function subscribeToFeatureFlagsUpdates(t) {
  if (!r.rr()) return;
  var e = nr.o();
  if (e._e()) {
    var _r = getAllFeatureFlags();
    _r && "function" == typeof t && t(_r);
  }
  return e.St(t);
}